import { useTranslation } from 'react-i18next';

const NyseStepFive = () => {
  const { t } = useTranslation(['contractModal']);

  return (
    <div className={'contracts-steps-body'}>
      <h2 style={{ textTransform: 'uppercase' }}>
        {t('contractModal:nyse_modal.section_2_nonprofessional_subscriber')}
      </h2>
      <div>
        <p>
          {t('contractModal:nyse_modal.nonprofessional_subscriber_definition')}
        </p>
        <p>
          {t('contractModal:nyse_modal.securities_professional_qualification')}
        </p>
        <p>{t('contractModal:nyse_modal.investment_advisor_definition')}</p>
        <p>{t('contractModal:nyse_modal.bank_employee_definition')}</p>
      </div>
    </div>
  );
};

export default NyseStepFive;
